module.exports = __webpack_public_path__ + "img/icon-paper-hijau.a3c41e94.svg";